import { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { Page, PageHeader } from '@/components/layout/Page';
import { ErrorState } from '@/components/ui/EmptyState';
import { Spinner } from '@/components/ui/Spinner';

import { useStaffMember } from '../api';
import { InviteLinkModal } from '../components/InviteLinkModal';
import { StaffForm } from '../components/StaffForm';

export function StaffEditorPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const staff = useStaffMember(id);
  const [invite, setInvite] = useState<{
    name: string;
    token: string;
    expiresAt: string;
  } | null>(null);
  const close = () => {
    void navigate('/settings/users', { replace: true });
  };

  if (invite)
    return (
      <Page>
        <PageHeader title="Staff member added" />
        <InviteLinkModal
          open
          kind="invite"
          personName={invite.name}
          token={invite.token}
          expiresAt={invite.expiresAt}
          onClose={close}
        />
      </Page>
    );
  if (!id) return <StaffForm user={null} onClose={close} onCreated={setInvite} />;
  if (staff.isPending)
    return (
      <Page>
        <Spinner label="Loading staff member" />
      </Page>
    );
  if (staff.isError)
    return (
      <Page>
        <ErrorState
          message="The staff member could not be loaded."
          onRetry={() => {
            void staff.refetch();
          }}
        />
      </Page>
    );
  return <StaffForm key={id} user={staff.data} onClose={close} onCreated={setInvite} />;
}
